var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"py-4 px-6 text-sm font-medium",attrs:{"role":"navigation","aria-label":"Primary navigation"}},[_c('ul',{staticClass:"flex space-x-3"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }